import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { ErrorFeedbackService } from '../../../service/error-feedback.service';
import { ToastrService } from 'ngx-toastr';
import { StringService } from '../../../service/string.service';
import { MailInfo } from './../../../model/mail-info.model';
import { LocationService } from '../../../service/location.service';
import { RejectReason } from '../../../model/mail-reject-reasons';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-card-header-info',
  templateUrl: './card-header-info.component.html',
  styleUrls: ['./card-header-info.component.scss']
})
// TODO: change this name and delete old one
export class CardHeaderInfoComponent implements OnInit, OnChanges, OnDestroy {
  @Input() mailInfo: MailInfo;
  @Input() mailType: string;
  @Input() rejectReason: RejectReason;
  @Input() page: string;
  @Input() pairMail: MailInfo; // ペアメール
  @Input() editEvent: EventEmitter<void>;
  @Output() deleted = new EventEmitter<any>();
  isAbleToEdit: boolean;
  ActionLogId: number;
  mailInfoBeforeCorrection: any;
  private subscriptions: Subscription = new Subscription();

  @Input() baseKeywords: Array<string> = [];
  matchedKeywords: Array<string> = [];
  unMatchedKeywords: Array<string> = [];
  skillSearchMatched: Array<string> = [];
  skillSearchUnmatched: Array<string> = [];

  constructor(
    private errorFeedbackService: ErrorFeedbackService,
    private toastrService: ToastrService,
    private stringService: StringService,
    private locationService: LocationService
  ) {}

  ngOnInit() {
    if (this.editEvent) {
      const editEventSub = this.editEvent.subscribe(_ => {
        this.correctMailInfo();
      });
      this.subscriptions.add(editEventSub);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['baseKeywords'] || changes['mailInfo']) {
      this.getMatchedKeywords();
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  getMatchedKeywords(): void {
    this.skillSearchMatched = [];
    this.skillSearchUnmatched = [];
    this.matchedKeywords = [];
    this.unMatchedKeywords = [];
    if (this.mailInfo.keywords) {
      for (const [key, value] of Object.entries(this.mailInfo.keywords)) {
        // 半角大文字に寄せて比較
        if (this.mailInfo.matched_skills
          && this.stringService.isHighlightTerget(this.mailInfo.matched_skills,key)) {
          if (this.baseKeywords.includes(key)) {
            this.insertIntoArray(this.skillSearchMatched, key);
          } else {
            this.insertIntoArray(this.skillSearchUnmatched, key);}
        } else if (this.baseKeywords.includes(key)) {
          this.insertIntoArray(this.matchedKeywords, key);
        } else {
          this.insertIntoArray(this.unMatchedKeywords, key);
        }
      }
    }
  }

  insertIntoArray(arr: Array<string>, key: string): void {
    if (key.match(/\w/)) {
      arr.unshift(key);
    } else {
      arr.push(key);
    }
  }

  correctMailInfo() {
    const params = {
      mail_info: this.mailInfo,
      mail_type: this.mailType,
      ai_mail_id: this.mailInfo.ai_mail_id,
      page: this.page,
      action_log_id: this.ActionLogId
    };
    const correctMailInfoSub = this.errorFeedbackService
      .getActionLogIdForCorrectingMailInfo(params)
      .subscribe(
        res => {
          if (!this.ActionLogId) {
            this.ActionLogId = res.body.action_log_id;
          }
          this.isAbleToEdit = true;
          this.mailInfoBeforeCorrection = Object.assign({}, this.mailInfo); // メール情報修正キャンセル時に、修正前の状態に戻すためのもの
        },
        error => {
          this.toastrService.error('現在、メール修正機能は使えません。');
        }
      );
    this.subscriptions.add(correctMailInfoSub);
  }

  sendCorrectedMailInfo() {
    const params = {
      mail_info: this.mailInfo,
      mail_type: this.mailType,
      ai_mail_id: this.mailInfo.ai_mail_id,
      action_log_id: this.ActionLogId
    };
    const sendCorrectedMailInfoSub = this.errorFeedbackService.sendCorrectedMailInfo(params).subscribe(
      res => {
        this.isAbleToEdit = false;
        if (res.status === 201) {
          this.toastrService.success('データの保存に成功しました。');
        }
      },
      error => {
        this.toastrService.error('データの保存に失敗しました。');
      }
    );
    this.subscriptions.add(sendCorrectedMailInfoSub);
  }

  cancelCorrectingMailInfo(e) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    this.mailInfo = this.mailInfoBeforeCorrection;
    this.isAbleToEdit = false;
    this.toastrService.success('メール修正のキャンセルしました。');
  }

  preventClickEvent(e) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }

  rejected(key: string): boolean {
    return this.rejectReason ? !this.rejectReason[key] : false;
  }
}
